import styles from "../../pages/CodesList.module.css";
import React from "react";

interface DetailsModelProps {
  showDetailsModal: boolean;
  detailsData: any;
  setShowDetailsModal: (show: boolean) => void;
  translateKeyToHebrew: (key: string) => string;
  formatDateTime: (value: string) => string;
}

const DetailsModel: React.FC<DetailsModelProps> = ({
  showDetailsModal,
  detailsData,
  setShowDetailsModal,
  translateKeyToHebrew,
  formatDateTime,
}) => {
  if (!showDetailsModal) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} style={{ maxWidth: 500 }}>
        <h3 className={styles.modalTitle}>פרטי מספר</h3>
        <div
          style={{
            marginBottom: 16,
            maxHeight: 300,
            overflowY: "auto",
            background: "#f8f9fa",
            borderRadius: 8,
            padding: 12,
          }}
        >
          {detailsData && Object.keys(detailsData).length > 0 ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: 14,
                direction: "rtl",
              }}
            >
              <tbody>
                {Object.entries(detailsData).map(([key, value]) => {
                  if (key === "conversationState") {
                    return null;
                  }
                  return (
                    <tr key={key}>
                      <td
                        style={{
                          fontWeight: "bold",
                          padding: "6px 8px",
                          borderBottom: "1px solid #eee",
                          width: "35%",
                        }}
                      >
                        {translateKeyToHebrew(key)}
                      </td>
                      <td
                        style={{
                          padding: "6px 8px",
                          borderBottom: "1px solid #eee",
                          direction: "rtl",
                          textAlign: "right",
                        }}
                      >
                        {typeof value === "string" &&
                        (key.toLowerCase().includes("date") ||
                          /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value))
                          ? formatDateTime(value)
                          : typeof value === "object" && value !== null
                          ? JSON.stringify(value)
                          : String(value)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <span>אין פרטים</span>
          )}
        </div>
        <div className={styles.modalActions}>
          <button
            className={styles.cancelButton}
            onClick={() => setShowDetailsModal(false)}
          >
            סגור
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailsModel; 